import { useEffect, useState } from "react";
import { Ifilter, IfilterEmpresa } from "../../../interfaces/IFilter";
import { IPaginacionComponent } from "../../../interfaces/base/ITable";
import EmpresaService from "../../../services/empresaService";
import { IEmpresa } from "../../../interfaces/IEmpresa";

const UseEmpresa = (filtro?: IfilterEmpresa) => {
  const [loadingTabla, setLoadingTabla] = useState<boolean>(false);
  const [items, setItems] = useState<IEmpresa[]>([]);
  const [dataEdit, setDataEdit] = useState<IEmpresa>(null!);
  const [filter, setFilter] = useState<Ifilter>({
    skip: 0,
    take: 50,
    search: "",
  });

  useEffect(() => {
    if (filtro) {
      setFilter(filtro);
    }
  }, [filtro]);

  const initial: Ifilter = {
    skip: 0,
    take: 50,
    search: "",
  };

  const onChangeTake = (take: number) => {
    setFilter({ ...filter, take: take, skip: 0 });
  };
  const onSkip = (skip: number) => {
    setFilter({ ...filter, skip: skip });
  };

  const [pagination, setPagination] = useState<IPaginacionComponent>({
    isLoading: loadingTabla,
    onChangeTake: onChangeTake,
    onChangeSkip: onSkip,
    totalPagesPagination: 10,
    skipPagination: filter.skip,
    takePagination: filter.take ?? 0,
    isVisible: true,
    total: 0,
  });

  const handleResetUpdate = () => {
    setFilter(initial);
  };

  const getEmpresa = () => {
    setLoadingTabla(true);
    EmpresaService.all(filter)
      .then((res) => {
        const pag: IPaginacionComponent = {
          isLoading: loadingTabla,
          onChangeTake: onChangeTake,
          onChangeSkip: onSkip,
          totalPagesPagination: res.data.pages,
          skipPagination: filter.skip,
          takePagination: filter.take ?? 0,
          isVisible: true,
          actualPage: res.data.page,
          total: res.data.total,
        };
        setPagination(pag);
        setLoadingTabla(false);
        setItems(res.data.items);
      })
      .catch((e: any) => {
        setLoadingTabla(false);
      });
  };

  const onChangeSearch = (
    event?: React.ChangeEvent<HTMLInputElement> | undefined,
    newValue?: string | undefined
  ) => {
    setFilter({ ...filter, skip: 0, search: newValue });
  };

  useEffect(() => {
    if (filter) {
      getEmpresa();
    }
  }, [filter]);

  return {
    items,
    filter,
    setFilter,
    loadingTabla,
    pagination,
    handleResetUpdate,
    onChangeSearch,
    dataEdit,
    setDataEdit,
  };
};

export { UseEmpresa };
